import React from 'react';
import Form from "react-bootstrap/Form";

const RecommendersInfoForm = ({fields, handleFieldChange, messages, page, isEdit}) => {
  return (
    <>
      <h3>推薦者 （正会員1名）</h3>
      <dl>
        <dt>推薦者<span className="red">*</span></dt>
        <dd>
          <Form.Group className="inlineFormControl" controlId="recommender" size="lg">
            <Form.Control
              type="text"
              name="recommender"
              value={fields.recommender}
              onChange={handleFieldChange}
            />
          </Form.Group>
          <p id="recommenderMessage" className="errorMessages">{messages.recommender.n}</p>
        </dd>

        <dt>推薦理由<span className="red">*</span></dt>
        <dd>
          <Form.Group controlId="reasonForRecommend">
            <Form.Control
              as="textarea"
              value={fields.reasonForRecommend}
              onChange={handleFieldChange}
              rows={3}
          />
          </Form.Group>
          <p>※会員の研究や活動への協力、学会への貢献など</p>
          <p id="reasonForRecommendMessage" className="errorMessages">{messages.reasonForRecommend.n}</p>
        </dd>
      </dl>
    </>

  );
}

export default RecommendersInfoForm;
